import React, { useMemo } from 'react';
import Combobox from '@ls/react-combobox-grid';
import { setGroup } from 'state/selections/actions';
import { useDispatch, useSelector } from 'react-redux';
import SelectionState from 'state/selections/SelectionState';
import {
  selectSelectedGroupValues,
  selectFetchingGroups,
  selectUncommittedGroupTypeEntity,
  selectUncommittedAllGroupEntities,
  selectSelectedGroupTypeValue
} from 'state/selections/selectors';

const GroupSelector = props => {
  const dispatch = useDispatch();
  const values = useSelector(
    selectSelectedGroupValues(SelectionState.UNCOMMITTED)
  );

  const loading = useSelector(selectFetchingGroups);
  const groupTypeEntity = useSelector(selectUncommittedGroupTypeEntity);
  const groupTypeGroups = useSelector(selectUncommittedAllGroupEntities);
  const options = useMemo(() => {
    return [...groupTypeGroups].sort(groupTypeEntity?.groupTypeGroupSorter);
  }, [groupTypeGroups, groupTypeEntity]);

  const onChange = React.useCallback(
    groups => {
      dispatch(setGroup(groups));
    },
    [dispatch]
  );
  return (
    <Combobox
      placeholder="Groups..."
      options={options}
      onChange={onChange}
      value={values}
      label={"Groups"}
      loading={loading}
      valueKey={groupTypeEntity?.emsGroupValueKey}
      labelKey={groupTypeEntity?.emsGroupLabelKey}
      columnDefs={groupTypeEntity?.groupPickerColumnDefs}
      variation={1}
      multi
    />
  );
};

export default GroupSelector;
